var $da9ccdb501807c66$exports = {};
$da9ccdb501807c66$exports = {
    "collectionLabel": `\u{5019}\u{88DC}`
};


export {$da9ccdb501807c66$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
